import { LayoutActions } from '@/app/core/store/types';
import { Inject, Injectable } from '@angular/core';
import { LayoutStore } from '@/app/core/store/layout.store';
import {
  USER_QUERIES,
  UserQueries
} from '@/app/platform/platform-core/user/store/types';

@Injectable({ providedIn: 'root' })
export class LayoutStoreActions implements LayoutActions {
  constructor(
    private readonly store: LayoutStore,
    @Inject(USER_QUERIES)
    private readonly userQueries: UserQueries
  ) {}

  closeSideBar(): void {
    this.store.update({
      isSideBarOpen: false
    });
  }

  openSideBar(): void {
    this.store.update({
      isSideBarOpen: true
    });
  }

  toggleSideBar(opened?: boolean): void {
    if (opened !== undefined) {
      this.store.update({
        isSideBarOpen: opened
      });

      return;
    }

    const { isSideBarOpen } = this.store.getValue();
    this.store.update({
      isSideBarOpen: !isSideBarOpen
    });
  }

  showLoginDialog(): void {
    if (this.loginDialogCanBeShown()) {
      this.store.update({
        showLoginDialog: true
      });
    }
  }

  closeLoginDialog(): void {
    this.store.update({
      showLoginDialog: false
    });
  }

  showAppMenu() {
    this.store.update({
      showAppMenu: true,
      isSideBarOpen: false
    });
  }

  closeAppMenu() {
    this.store.update({
      showAppMenu: false
    });
  }

  toggleLoadingBar(loading?: boolean): void {
    if (loading !== undefined) {
      this.store.update({
        isLoading: loading
      });

      return;
    }

    const { isLoading } = this.store.getValue();
    this.store.update({
      isLoading: !isLoading
    });
  }

  toggleFullscreen(fullscreen?: boolean) {
    const { isFullscreen } = this.store.getValue();
    const f = fullscreen ?? !isFullscreen;
    this.store.update({
      isFullscreen: f
    });
  }

  private loginDialogCanBeShown(): boolean {
    return !this.userQueries.getIsAnyUserAuthenticated();
  }
}
